import { EventEmitter } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ConjunctionEnum } from "../../../../shared/models/conjunction.enum";
import { ResolvedRequestOptionsService } from "../../../services/resolved-request-options";
var PollinationPreferenceGroupComponent = /** @class */ (function () {
    function PollinationPreferenceGroupComponent(routeData) {
        this.routeData = routeData;
        this.canDelete = true;
        this.groupLabel = '';
        this.shouldHideConjunction = false;
        this.onDelete = new EventEmitter();
        this.onFocus = new EventEmitter();
        this.onDeleteLastItem = new EventEmitter();
        this.pollinationTypes = this.routeData.requestOptions.pollinationTypes;
    }
    Object.defineProperty(PollinationPreferenceGroupComponent.prototype, "conjunctionEnum", {
        get: function () {
            return ConjunctionEnum;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PollinationPreferenceGroupComponent.prototype, "items", {
        get: function () {
            return this.preferenceGroup.get("items");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PollinationPreferenceGroupComponent.prototype, "hasItems", {
        get: function () {
            return this.items && this.items.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    PollinationPreferenceGroupComponent.prototype.delete = function () {
        if (this.canDelete) {
            this.onDelete.emit(this.index);
        }
    };
    PollinationPreferenceGroupComponent.prototype.deleteLastItem = function () {
        if (this.hasItems) {
            this.onDeleteLastItem.emit(this.index);
        }
    };
    PollinationPreferenceGroupComponent.prototype.focus = function () {
        this.onFocus.emit(this.index);
    };
    return PollinationPreferenceGroupComponent;
}());
export { PollinationPreferenceGroupComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/pollination-instructions/pollination-preference-group/pollination-preference-group.component.ts.pre-build-optimizer.js